import apiWrapper from 'Helpers/apiWrapper'

const endpoints = ((baseURL) => {
  return {
    getOnSend: (idList) => `${baseURL}/email/list/${idList}/sending/search`
  }
})(process.env.BESEND_URL)

export const beSendPostOnSend = (idList, params) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.getOnSend(idList),
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(params)
  }).then(({ data }) => data)
}
